
/* ============================== src/components/menus/taskMenu.js ============================== */
// path: frontend/src/components/menus/taskMenu.js
/**
 * Состав контекстного меню задачи. Единственный источник для всех мест,
 * где задача показывается с действиями: канбан, список, календарь.
 *
 * RBAC-флаги — только с сервера:
 *   - task.permissions.allowedStatuses — переходы (canChangeTaskStatus);
 *   - capabilities.editRoles — удаление (admin);
 *   - capabilities.createTask — «Копировать» / «В шаблон».
 *
 * Legacy-fallback снят в PR 2b-3: TaskCard и TasksList передают
 * capabilities через useAuth().
 */
import { TASK_STATUSES } from "../../utils/constants";
import { ICONS } from "../iconsData";

export function buildTaskMenu({
  task,
  capabilities,
  openTask,
  onMove,
  onDelete,
  onCopy,
  onMakeTemplate,
}) {
  const serverStatuses = Array.isArray(task.permissions?.allowedStatuses)
    ? task.permissions.allowedStatuses
    : [];

  const statusChoices = onMove
    ? serverStatuses.filter((s) => s !== task.status)
    : [];

  const canDelete = !!onDelete && Boolean(capabilities?.editRoles);
  const canCopy = !!onCopy && Boolean(capabilities?.createTask);
  const canMakeTemplate = !!onMakeTemplate && Boolean(capabilities?.createTask);

  const hasStatusBlock = statusChoices.length > 0;
  const hasActionsBlock = canCopy || canMakeTemplate;
  const hasDestructiveBlock = canDelete;

  return [
    {
      id: "open",
      label: "Открыть",
      icon: ICONS.eye,
      onClick: () => openTask(task.id),
    },
    hasStatusBlock && { type: "divider" },
    hasStatusBlock && { type: "header", label: "Перевести в статус" },
    ...statusChoices.map((s) => ({
      id: s,
      label: TASK_STATUSES[s]?.label || s,
      onClick: () => onMove(task.id, s),
    })),
    hasActionsBlock && { type: "divider" },
    canCopy && {
      id: "copy",
      label: "Копировать",
      icon: ICONS.copy,
      onClick: () => onCopy(task.id),
    },
    canMakeTemplate && {
      id: "template",
      label: "В шаблон",
      icon: ICONS.star,
      onClick: () => onMakeTemplate(task.id),
    },
    hasDestructiveBlock && { type: "divider" },
    canDelete && {
      id: "del",
      label: "Удалить задачу",
      icon: ICONS.trash,
      danger: true,
      onClick: () => onDelete(task),
    },
  ].filter(Boolean);
}
